import { Divider } from '@/components/layout';
import { Stack } from '@/components/layout/stack';
import { Button, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { AddNewKitSheetModal } from '@/features/player/components/player-profile/player-equipment/add-kit-sheet';
import { ClubsInfo } from '@/features/player/components/player-profile/player-equipment/clubs-info';
import { KitItem } from '@/features/player/components/player-profile/player-equipment/kit-item';
import { ListKitsSheetModal } from '@/features/player/components/player-profile/player-equipment/list-kit-sheet';
import { useStyles } from '@/features/player/components/player-profile/player-equipment/styles';
import { PlayerWelcomeKit } from '@/features/player/components/types';
import { useScaling } from '@/hooks/use-scaling';
import { colors } from '@/theme/colors';
import { Activity } from 'react';
import { StyleSheet } from 'react-native';

export function PlayerProfileEquipment({
  welcomeKit,
  profileId,
  clubsneeded,
  dominantHand,
  height,
}: {
  welcomeKit: PlayerWelcomeKit[];
  profileId: string;
  clubsneeded: boolean;
  dominantHand: string;
  height: string;
}) {
  const styles = useStyles();
  const { scale, isTablet } = useScaling();
  const kitPreviewLimit = isTablet ? 5 : 3;
  const displayWelcomeKit = welcomeKit.slice(0, kitPreviewLimit);
  const showAllVisibility = isTablet ? (welcomeKit.length ?? 0) > 5 : (welcomeKit.length ?? 0) > 3;

  return (
    <Stack
      paddingY={scale(12)}
      paddingX={!isTablet ? undefined : scale(16)}
      backgroundColor={isTablet ? undefined : colors['2']}
      flexGrow={1}>
      <Stack
        paddingX={scale(16)}
        direction="row"
        justify="space-between"
        align="center"
        marginBottom={scale(12)}>
        <Text
          variant="Font Montserrat/Subtitle/Minimize 1 Bold 11px"
          transform="uppercase"
          fontWeight={'800'}
          style={styles.title}>
          {STRINGS.player.profile.equipment.title}
        </Text>
        <Activity mode={showAllVisibility ? 'visible' : 'hidden'}>
          <ListKitsSheetModal welcomeKit={welcomeKit} />
        </Activity>
      </Stack>
      <Stack paddingX={scale(16)} gap={scale(16)}>
        <Stack gap={scale(8)}>
          {displayWelcomeKit.map((item, index) => (
            <KitItem
              key={`${item.level}-${item.date}-${item.coachName}-${index}`}
              level={item.level ?? 0}
              dateText={item.date ?? ''}
              coachName={item.coachName ?? ''}
            />
          ))}
        </Stack>
        <AddNewKitSheetModal profileId={profileId}>
          <Button style={styles.addNewKitButton}>
            <Button.Icon name="IcPlus" size={scale(24)} color={colors['0']} />
            <Button.Text
              variant={
                isTablet ? 'Font Inter/Subtitle/Medium 12px' : 'Font Inter/Subtitle/Regular 11px'
              }
              transform="uppercase">
              {STRINGS.player.profile.equipment.addNewKit}
            </Button.Text>
          </Button>
        </AddNewKitSheetModal>
      </Stack>
      <Divider spacing={scale(12)} thickness={StyleSheet.hairlineWidth} />
      <Stack paddingX={scale(16)}>
        <ClubsInfo clubsneeded={clubsneeded} dominantHand={dominantHand} height={height} />
      </Stack>
    </Stack>
  );
}
